export default {
  'home.metaTitle': 'USFans Spreadsheet 2026 – Hallazgos, Reseñas, QC y Guía de Compra',
  'home.metaDescription':
    'Explora el USFans Spreadsheet con hallazgos de productos, guías de QC, información de envío, reseñas, consejos de seguridad, cupones y recursos de compra prácticos para 2026.',

  'home.navHome': 'Inicio',
  'home.navSpreadsheet': 'Spreadsheet',
  'home.navCategories': 'Categorías',
  'home.navGuides': 'Guías',
  'home.navShoppingGuide': 'Guía de compra',
  'home.navReviews': 'Reseñas',
  'home.navShipping': 'Envío',
  'home.navSafety': 'Seguridad',
  'home.navVisit': 'Visitar sitio principal',

  'home.heroBadge': 'Centro de recursos del USFans Spreadsheet',
  'home.heroTitle': 'Encuentra mejores productos con el USFans Spreadsheet',
  'home.heroSubtitle':
    'El USFans Spreadsheet facilita la investigación de productos al organizar hallazgos útiles, categorías, recursos de QC, guías de envío, reseñas e información de compra en un solo lugar con buscador.',
  'home.heroSubtitle2':
    'Tanto si eres nuevo en USFans como si ya conoces el proceso, empieza aquí para investigar productos, comparar opciones y entender el proceso de compra antes de decidir.',
  'home.heroTrust': 'Recurso informativo independiente • Actualizado con frecuencia • Ideal para principiantes',
  'home.ctaSpreadsheet': 'usfans spreadsheet',
  'home.ctaBuyNow': 'comprar ahora',
  'home.ctaGuide': 'Leer la guía para principiantes',

  'home.catTitle': 'Explora las categorías del USFans Spreadsheet',
  'home.catSubtitle':
    'Navega por categorías organizadas y ve directo a los productos que buscas en el sitio principal.',
  'home.catPlaceholder': 'Selecciona una categoría',
  'home.catBrowseAll': 'Ver todas las categorías',
  'home.catShoes': 'Zapatos',
  'home.catHoodies': 'Sudaderas / Suéteres',
  'home.catTshirts': 'Camisetas',
  'home.catJackets': 'Chaquetas',
  'home.catPants': 'Pantalones / Pantalones cortos',
  'home.catHeadwear': 'Gorras',
  'home.catSets': 'Conjuntos',
  'home.catUnderwear': 'Ropa interior',
  'home.catJersey': 'Camisetas deportivas',
  'home.catAccessories': 'Accesorios',
  'home.catBags': 'Bolsos',
  'home.catBelts': 'Cinturones',
  'home.catPerfumes': 'Perfumes',
  'home.catOther': 'Otras cosas',

  'home.whatTitle': '¿Qué es el USFans Spreadsheet?',
  'home.whatP1':
    'El USFans Spreadsheet es un recurso estructurado para descubrir e investigar enlaces de productos, categorías e información de compra asociada a USFans.',
  'home.whatP2':
    'En lugar de buscar entre publicaciones dispersas, puedes explorar categorías organizadas, guías, reseñas, información de QC, recursos de envío y preguntas frecuentes en un solo lugar.',
  'home.whatCta': 'Explorar el Spreadsheet',

  'home.whyTitle': '¿Por qué usar un USFans Spreadsheet?',
  'home.whySubtitle': 'Algunas razones por las que el spreadsheet te ayuda a comprar de forma más eficiente.',
  'home.why1Title': 'Investiga más rápido',
  'home.why1Desc': 'Encuentra productos y recursos relevantes sin buscar en decenas de páginas no relacionadas.',
  'home.why2Title': 'Compara opciones',
  'home.why2Desc': 'Usa información estructurada y tablas de comparación antes de decidir.',
  'home.why3Title': 'Entiende el QC',
  'home.why3Desc': 'Aprende qué significan las fotos de QC y qué debes revisar antes del envío.',
  'home.why4Title': 'Entiende el envío',
  'home.why4Desc': 'Aprende cómo el peso, el destino, el empaque y los métodos de envío afectan los costos totales.',

  'home.reviewTitle': 'Reseña de USFans',
  'home.reviewP':
    '¿Estás pensando en usar USFans? Lee nuestra reseña independiente de USFans que cubre cómo funciona el proceso, ventajas, limitaciones, QC, almacén, envío, seguridad y problemas comunes.',
  'home.review1': 'Cómo funciona el proceso',
  'home.review2': 'Ventajas y limitaciones',
  'home.review3': 'QC y almacén',
  'home.review4': 'Envío',
  'home.review5': 'Seguridad y consideraciones del usuario',
  'home.review6': 'Problemas comunes',
  'home.reviewCta': 'Leer la reseña de USFans',

  'home.shipTitle': 'Costo de envío de USFans',
  'home.shipP':
    'El envío puede afectar significativamente el costo final de un pedido. Aprende cómo puede variar el costo de envío según distintos factores.',
  'home.ship1': 'Destino',
  'home.ship2': 'Peso y volumen del paquete',
  'home.ship3': 'Línea de envío y empaque',
  'home.ship4': 'Seguro y cambios de temporada',
  'home.shipNote': 'Los precios varían — consulta las tarifas actuales y estima antes de pagar.',
  'home.shipCta': 'Ver guía de costo de envío',

  'home.couponTitle': 'Cupón y código de descuento de USFans',
  'home.couponP':
    'Un recurso dedicado a cupones de USFans, códigos de descuento, códigos promocionales y cupones de envío. Cada página de cupón muestra estado, fecha de verificación, vencimiento, restricciones y cómo aplicarlo.',
  'home.coupon1': 'Estado y fecha de verificación',
  'home.coupon2': 'Vencimiento y restricciones',
  'home.coupon3': 'Fuente',
  'home.coupon4': 'Cómo aplicarlo',
  'home.couponNote': 'No se encontró ningún código activo verificado.',
  'home.couponCta': 'Ver cupones actuales',

  'home.wareTitle': 'Almacén de USFans',
  'home.wareP':
    'Entiende qué hace el almacén: fotos de QC, almacenamiento, consolidación de paquetes, empaque, preparación de envío, inspección y posibles límites de almacenamiento.',
  'home.ware1': 'Fotos de QC e inspección',
  'home.ware2': 'Almacenamiento',
  'home.ware3': 'Consolidación de paquetes',
  'home.ware4': 'Empaque y preparación de envío',
  'home.ware5': 'Posibles límites de almacenamiento',
  'home.wareCta': 'Leer la guía del almacén',

  'home.legitTitle': '¿Es USFans legítimo?',
  'home.legitP':
    'Obtén una respuesta directa a la intención de búsqueda. Entiende qué es USFans, cómo funciona el flujo de compra y qué riesgos y verificaciones debes conocer antes de pagar.',
  'home.legit1': 'Qué es USFans (y qué no es)',
  'home.legit2': 'Cómo funciona el flujo de compra',
  'home.legit3': 'Qué riesgos entender',
  'home.legit4': 'Cómo verificar la información',
  'home.legit5': 'Qué revisar antes de pagar',
  'home.legitNote': 'Sin afirmaciones sin respaldo — lee los hechos antes de decidir.',
  'home.legitCta': 'Leer la guía de legitimidad',

  'home.compTitle': 'Comparación del USFans Spreadsheet',
  'home.compHeader1': 'Recurso',
  'home.compHeader2': 'Propósito principal',
  'home.compHeader3': 'Ideal para',
  'home.compHeader4': 'Info de QC',
  'home.compHeader5': 'Info de envío',
  'home.compHeader6': 'Para principiantes',
  'home.compRow1c1': 'Spreadsheet',
  'home.compRow1c2': 'Investigación de productos',
  'home.compRow1c3': 'Encontrar productos',
  'home.compRow1c4': 'Varía',
  'home.compRow1c5': 'Guía',
  'home.compRow1c6': 'Sí',
  'home.compRow2c1': 'Reseña',
  'home.compRow2c2': 'Investigación de la plataforma',
  'home.compRow2c3': 'Evaluación',
  'home.compRow2c4': 'Sí',
  'home.compRow2c5': 'Sí',
  'home.compRow2c6': 'Sí',
  'home.compRow3c1': 'Guía de QC',
  'home.compRow3c2': 'Investigación de calidad',
  'home.compRow3c3': 'QC',
  'home.compRow3c4': 'Sí',
  'home.compRow3c5': 'Limitada',
  'home.compRow3c6': 'Sí',
  'home.compRow4c1': 'Guía de envío',
  'home.compRow4c2': 'Investigación de entrega',
  'home.compRow4c3': 'Envío',
  'home.compRow4c4': 'No',
  'home.compRow4c5': 'Sí',
  'home.compRow4c6': 'Sí',

  'home.guidesTitle': 'Últimas guías de USFans',
  'home.guidesSubtitle': 'Guías frescas y originales para investigar y comprar con confianza.',
  'home.guidesRead': 'Leer artículo',
  'home.guidesUpdated': 'Actualizado',

  'home.faqTitle': 'Preguntas frecuentes',
  'home.faqQ1': '¿Qué es el USFans Spreadsheet?',
  'home.faqA1':
    'Es un recurso organizado que reúne enlaces de productos, categorías e información de compra en un solo lugar con buscador para investigar productos.',
  'home.faqQ2': '¿Es USFans legítimo?',
  'home.faqA2':
    'USFans es un flujo de investigación y compra. Siempre verifica los enlaces, revisa la información del vendedor y entiende los riesgos antes de realizar un pago.',
  'home.faqQ3': '¿Cuánto cuesta el envío de USFans?',
  'home.faqA3':
    'El envío varía según el destino, peso, volumen, línea, empaque y temporada. Consulta las tarifas actuales antes de pagar.',
  'home.faqQ4': '¿Hay códigos de cupón activos de USFans?',
  'home.faqA4':
    'Los códigos cambian con frecuencia. Si no hay un código activo verificado, toma el precio regular como referencia.',
  'home.faqQ5': '¿Qué debo revisar antes de comprar?',
  'home.faqA5':
    'Revisa las fotos de QC, estima el envío, confirma los datos del vendedor, revisa las políticas de devolución y guarda registros de tu pedido.',

  'home.finalTitle': '¿Listo para explorar?',
  'home.finalSubtitle':
    'Empieza con el USFans Spreadsheet y luego usa nuestras guías para investigar productos, entender el QC y comparar opciones de envío.',
  'home.finalCta': 'Explorar el USFans Spreadsheet',

  'home.footerDesc':
    'Un recurso informativo independiente sobre el USFans Spreadsheet. No está afiliado ni respaldado por USFans salvo que se indique explícitamente.',
  'home.footerResources': 'Recursos',
  'home.footerSpreadsheet': 'USFans Spreadsheet',
  'home.footerGuides': 'Guías',
  'home.footerReviews': 'Reseñas',
  'home.footerShipping': 'Envío',
  'home.footerCoupons': 'Cupones',
  'home.footerWarehouse': 'Almacén',
  'home.footerQC': 'QC',
  'home.footerSafety': 'Seguridad',
  'home.footerFaq': 'FAQ',
  'home.footerCompany': 'Empresa',
  'home.footerAbout': 'Acerca de',
  'home.footerContact': 'Contacto',
  'home.footerEditorial': 'Política editorial',
  'home.footerPrivacy': 'Política de privacidad',
  'home.footerTerms': 'Términos',
  'home.footerDisclaimer': 'Aviso legal',
  'home.footerLanguages': 'Idiomas',
  'home.footerRights': 'Todos los derechos reservados.',
};